import React, { memo, useEffect, useContext } from 'react';
import { context as Context } from '@gp/components/Context';
import { reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import DataTime from '@gp/components/DataTime';
import KeyInfomation from './components/KeyInfomation';
import AboutNews from './components/AboutNews';
import Projects from './components/Projects';
import useRequestDetailsData from './hook/useRequestDetailsData';
import './index.scss';

interface OverviewDetailsPropsType {
  loading?: boolean;
}

const DEFAULT_PROPS: OverviewDetailsPropsType = {
  loading: true,
};

function OverviewDetails(props: OverviewDetailsPropsType) {
  const { loading } = props;

  const { studioId, studioName, headerLoading, headerData, }: StudioOverallDetailContextTypes =
    useContext(Context) || {};

  const {
    dataTime,
    keyInfomatLoading,
    keyInfomatData,
    aboutLoading,
    aboutData,
    newsLoading,
    newsData,
    projectsLiveLoading,
    projectsLiveData,
    projectsInDevLoading,
    projectsInDevData,
    handleProjectLiveChange,
  } = useRequestDetailsData({ studioId });

  // 页面打点
  useEffect(() => {
    reportOperationLog(
      Object?.assign(
        ALL_REPORT_OPERATION_LOG['STUDIO_OVERALL_DETAILS_OVERVIEW'],
        {
          uidType: 'studio_id',
          uid: studioId,
          extInfo: studioName,
        },
      ),
    );
  }, []);

  return (
    <div className="dbg-studio-overall-details-overview">
      <KeyInfomation
        loading={keyInfomatLoading}
        data={keyInfomatData}
        dataTime={dataTime}
      />
      <AboutNews
        loading={headerLoading || aboutLoading || newsLoading}
        studioId={studioId}
        headerData={headerData}
        aboutData={aboutData}
        newsData={newsData}
      />
      <Projects
        // loading={projectsLiveLoading || projectsInDevLoading}
        projectsLiveLoading={projectsLiveLoading}
        projectsInDevLoading={projectsInDevLoading}
        liveData={projectsLiveData}
        inDevData={projectsInDevData}
        onProjectLiveChange={handleProjectLiveChange}
      />
    </div>
  );
}

OverviewDetails.defaultProps = DEFAULT_PROPS;

export default memo(OverviewDetails);
